import React, { useEffect, useRef, useState } from "react";

import { Form, Button, Label, Col, Card } from "reactstrap";
import ReCAPTCHA from "react-google-recaptcha";
import PRInput from "../common/PRInput";
import PRCheckbox from "../common/PRCheckbox";
import HomeSelect from "./home-auto-select";
import HomeQA from "./home-qa";
import HomeAttach from "./home-attach";
import HomeLocation from "./home-location";
import HomeHyperlink from "./home-hyperlink";
import { WebMapView } from "./home-map";

export default function HomeForm(props) {
  //  console.log("props-home-form", props);

  const recaptchaRef = useRef(null);
  const [step, setStep] = useState(1);
  const [screenshot, setScreenshot] = useState(null);

    useEffect(() => {
        props.fstate.problemtype.valueDesc = "";
        props.fstate.problemLocation.valueDesc = "";
    }, []);

  const submitForm = (e) => {
      e.preventDefault();

    props.setBtnSubmitDisabled(true);
    // props.loadDiv("show", "In process...");
    if (props.usecaptcha) {
      recaptchaRef.current.execute();
    } else {
        //console.log("Props",props);
      props.submitForm();
    }
  };

    const onChange = (value) => {
    props.submitForm();
  };

  const openStep = (e, step) => {
      setStep(step);
   
      if (step === 1) { problemTypeDescription();}
  };

  const showPRdescription = () => {
    let a = props.problemTypes.find(
      (e) => e.problemSid === props.fstate.problemtype.value
    );
    if (a) {
      return a.description;
    } else return "";
  };

  const saveScreenshot = (image) => {
   // console.log(image);
    setScreenshot(image);
    };

    const problemTypeDescription = () => {
        if (props.fstate.problemtype.value) {
            let list = props.problemTypes.filter(a => a.problemSid === props.fstate.problemtype.value);

            if (list && list[0]) props.fstate.problemtype.valueDesc = list[0].description; else props.fstate.problemtype.valueDesc = "";
        }
    }

  return (
      <div className="maxElement">
       
      <Form
        innerRef={props.formRef}
              className="form"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <Col>
           {props.fstate.reportTitle.disable===false ? (
            <div className="d-flex justify-content-center">
              <Label className="title" for="reportTitle">
                <div className="d-flex justify-content-center">
                  <span
                    className={
                      props.fstate.reportTitle.fontWeight
                        ? "label-font"
                        : ""
                    }
                  >
                    {props.translate(
                      props.lang,
                      props.fstate.reportTitle.label
                    )}
                  </span>
                </div>
              </Label>
            </div>
          ) : (
            ""
                      )}



          {step === 1 ? (
                      <>
                  {props.fstate.reportInfoOnTop.disable === false ? (
                      <div className="d-flex ">
                          <Label className="infoTop" for="reportInfoOnTop">
                              <div className="d-flex ">
                                  <span
                                      className={
                                          props.fstate.reportInfoOnTop.fontWeight
                                              ? "label-font"
                                              : ""
                                      }
                                  >
                                      {props.translate(
                                          props.lang,
                                          props.fstate.reportInfoOnTop.label
                                      )}
                                  </span>
                              </div>
                          </Label>
                      </div>
                  ) : (
                          ""
                      )}


              <div className="d-flex justify-content-end">
                <HomeHyperlink
                  isHome={props.isHome}
                  translate={props.translate}
                  lang={props.lang}
                  changeLang={props.changeLang}
                  useTranslation={props.useTranslation}
                  useFontOptions={props.useFontOptions}
                                  changePage={props.changePage}
                                  fontSize={props.fontSize}
                                  changeFont={props.changeFont}
                />
              </div>

              <Card className="cardStyle">
                <HomeSelect
                  problemTypes={props.problemTypes}
                  fstate={props.fstate}
                  onchange={props.onchange}
                  getQA={props.getQA}
                  problemTypesCommon={props.problemTypesCommon}
                  translate={props.translate}
                   lang={props.lang}
                                  
                />

                <HomeQA
                  allQ={props.allQ}
                  fstate={props.fstate}
                  curQ={props.curQ}
                  curAall={props.curAall}
                  curA={props.curA}
                  selectedQA={props.selectedQA}
                  translate={props.translate}
                  lang={props.lang}
                  onSelectAnswer={props.onSelectAnswer}
                  nextQA={props.nextQA}
                  Guid={props.Guid}
                />
              </Card>

              <Card className="cardStyle">

                              {/*
                <HomeLocation
                                  fstate={props.fstate}
                                  translate={props.translate}
                                  lang={props.lang}
                                  validate={props.validate}
                                  onSearchChange={props.onSearchChange}
                                  Guid={props.Guid}
                                  setAndValidate={props.setAndValidate}
                                  updateLocationAddress={props.updateLocationAddress}
                                  saveScreenshot={saveScreenshot}
                                  gisAddreses={props.gisAddreses}
                                  maprefresh={props.maprefresh}
                                  extent={props.extent}
                                  geomUrl={props.geomUrl}
                                  geomToken={props.geomToken}
                                  gcoderUrl={props.gcoderUrl}
                                  gcoderToken={props.gcoderToken}
                                  addressField={props.addressField}
                                  geomTokenRequired={props.geomTokenRequired}
                                  gcoderTokenRequired={props.gcoderTokenRequired}
                                  loadDiv={props.loadDiv}
                                  getAddreses={props.getAddreses}
                              />*/}
                              <WebMapView 
                                  fstate={props.fstate}
                                  translate={props.translate}
                                  lang={props.lang}
                                  validate={props.validate}
                                  onSearchChange={props.onSearchChange}
                                  Guid={props.Guid}
                                  setAndValidate={props.setAndValidate}
                                  updateLocationAddress={props.updateLocationAddress}
                                  saveScreenshot={saveScreenshot}
                                  gisAddreses={props.gisAddreses}
                                  maprefresh={props.maprefresh}
                                  extent={props.extent}
                                  sp={props.sp}
                                  geomUrl={props.geomUrl}
                                  geomToken={props.geomToken}
                                  gcoderUrl={props.gcoderUrl}
                                  gcoderToken={props.gcoderToken}
                                  addressField={props.addressField}
                                  geomTokenRequired={props.geomTokenRequired}
                                  gcoderTokenRequired={props.gcoderTokenRequired}
                                  loadDiv={props.loadDiv}
                                  getAddreses={props.getAddreses}
                                  clearAlerts={props.clearAlerts}
                                  mapZoom={props.mapZoom}

                              />

                {/* <WebMapView 
                  fstate={props.fstate}
                  onchangeaddress={props.updateLocationAddress}
                  saveScreenshot={saveScreenshot}
                /> */}
                              <br/>

                              <PRInput
                                  elem={props.fstate.locationDetails}
                                  validate={props.validate}
                                  translate={props.translate}
                                  placeholder={props.fstate.locationDetails.placeholder}
                                  lang={props.lang}
                              />
              </Card>

                          <div className="d-flex justify-content-center">
                              <Button
                                  className={
                                      props.fstate.problemLocation.value &&
                                          props.fstate.problemtype.value && ((props.fstate.locationDetails.required && props.fstate.locationDetails.value) || (!props.fstate.locationDetails.required)) &&
                                          !(props.curA && props.curQ)
                                          ? ""
                                          : "noAllowed"
                                  }

                  color={
                    props.fstate.problemLocation.value &&
                                          props.fstate.problemtype.value && ((props.fstate.locationDetails.required && props.fstate.locationDetails.value) || (!props.fstate.locationDetails.required)) && 
                    !(props.curA && props.curQ)
                      ? "info"
                      : "secondary"
                  }
                  onClick={(e) => {
                    if (
                      props.fstate.problemLocation.value &&
                        props.fstate.problemtype.value && ((props.fstate.locationDetails.required && props.fstate.locationDetails.value) || (!props.fstate.locationDetails.required)) && 
                      !(props.curA && props.curQ)
                    )
                      openStep(e, 2);
                  }}
                >
                  {props.translate(props.lang, "Next")}
                </Button>
              </div>
            </>
          ) : (
            ""
          )}

          {step === 2 ? (
            <>
              <Card className="cardStyle">
                <div className="selectedData">
                  <div className="row">
                    <div className="col">
                      {props.translate(props.lang, "TypeOfProblemLabel")}
                    </div>
                    <div className="col font-weight-bold">
                      {showPRdescription()}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      {props.translate(props.lang, "LocationOfProblemLabel")}
                    </div>
                    <div className="col font-weight-bold">
                      {" "}
                      {props.fstate.problemLocation.value}
                    </div>
                  </div>
                </div>
              </Card>
              <Card className="cardStyle">
                <div>
                                  {/*<PRInput
                    elem={props.fstate.locationDetails}
                    validate={props.validate}
                    translate={props.translate}
                    placeholder={props.fstate.locationDetails.placeholder}       
                    lang={props.lang}
                  /> */}

                  <PRInput
                    elem={props.fstate.additionalDetail}
                    validate={props.validate}
                    translate={props.translate}
                     placeholder={props.fstate.additionalDetail.placeholder}     
                    lang={props.lang}
                  />

                  <HomeAttach
                    fstate={props.fstate}
                    translate={props.translate}
                    lang={props.lang}
                    validate={props.validate}
                    onChangeImageOption={props.onChangeImageOption}
                    attach={props.attach}
                    deleteAttach={props.deleteAttach}
                    previewAttach={props.previewAttach}
                    imageOption={props.imageOption}
                    imageList={props.imageList}
                    prevFile={props.prevFile}
                  />
                </div>
              </Card>
              <div className="d-flex justify-content-center">
                <Button
                  color="info"
                  onClick={(e) => {
                    openStep(e, 1);
                  }}
                >
                  {props.translate(props.lang, "Back")}
                </Button>
                <Button
                  color="info"
                  onClick={(e) => {
                    openStep(e, 3);
                  }}
                >
                  {props.translate(props.lang, "Next")}
                </Button>
              </div>
            </>
          ) : (
            ""
          )}

          {step === 3 ? (
            <>
              <Card className="cardStyle">
                <div className="selectedData">
                  <div className="row  font-weight-bold">
                    <div className="col">
                      {props.translate(props.lang, "RequestSummaryLabel")}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-sm-4">
                      {props.translate(props.lang, "TypeOfProblemLabel")}
                    </div>
                    <div className="col col-sm-6 font-weight-bold">
                      {showPRdescription()}
                    </div>

                    <div>
                      <Button
                        color="link"
                        onClick={(e) => {
                          openStep(e, 1);
                        }}
                      >
                        Edit
                      </Button>
                      {/* <FontAwesomeIcon icon={faPen} id={props.fstate.problemLocation.name+"p"} /> */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-sm-4">
                      {props.translate(props.lang, "LocationOfProblemLabel")}
                    </div>
                    <div className="col col-sm-6 font-weight-bold">
                      {" "}
                      {props.fstate.problemLocation.value}
                    </div>
                    <div>
                      <Button
                        color="link"
                        onClick={(e) => {
                          openStep(e, 1);
                        }}
                      >
                        Edit
                      </Button>
                      {/* <FontAwesomeIcon icon={faPen} id={props.fstate.problemLocation.name+"p"} /> */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-sm-4"></div>
                    <div className="col col-sm-6 font-weight-bold">
                      <img
                        id="screenshotImage"
                        src={screenshot}
                        alt="name"
                      ></img>
                    </div>{" "}
                  </div>

                  {props.fstate.locationDetails.value ? (
                    <div className="row">
                      <div className="col col-sm-4">
                        {props.translate(
                          props.lang,
                          "LocationDetailLabel"
                        )}
                      </div>
                      <div className="col col-sm-6 font-weight-bold">
                        {props.translate(
                          props.lang,
                          props.fstate.locationDetails.value
                        )}
                      </div>
                      <div>
                        <Button
                          color="link"
                          onClick={(e) => {
                            openStep(e, 1);
                          }}
                        >
                          Edit
                        </Button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {props.fstate.additionalDetail.value ? (
                    <div className="row">
                      <div className="col col-sm-4">
                        {props.translate(
                          props.lang,
                          "AddDetailLabel"
                        )}
                      </div>
                      <div className="col col-sm-6 font-weight-bold">
                        {props.translate(
                          props.lang,
                          props.fstate.additionalDetail.value
                        )}
                      </div>
                      <div>
                        <Button
                          color="link"
                          onClick={(e) => {
                            openStep(e, 2);
                          }}
                        >
                          Edit
                        </Button>
                      </div>
                    </div>
                  ) : (
                 "")}



                                  {(props.fstate.imageList && props.fstate.imageList.length>0) ? (
                                      <div className="row">
                                          <div className="col col-sm-4">
                                              {props.translate(
                                                  props.lang,
                                                  "AttachmentsLabel"
                                              )}
                                          </div>
                                          <div className="col col-sm-6 font-weight-bold">
                                              {props.fstate.imageList.map((a) => (
                                                 
                                                  <img id="{a.Guid}2" className="thumbnail" alt="" src={a.data}></img>
                                          
                                              ))}
                                          </div>
                                          <div>
                                              <Button
                                                  color="link"
                                                  onClick={(e) => {
                                                      openStep(e, 2);
                                                  }}
                                              >
                                                  Edit
                                            </Button>
                                          </div>
                                      </div>
                                  ) : (
                                          "")}


                              
                                  
                                 
                                      
                                 
                </div>
              </Card>
              <Card className="cardStyle">
                              {/*<div className="flex"> */}
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.firstName}
                      validate={props.validate}
                      translate={props.translate}
                                      lang={props.lang}
                                      errmsg={props.fstate.firstName.errorlabel}
                                      placeholder={props.fstate.firstName.placeholder}
                    />
                  </div>{" "}
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.lastName}
                      validate={props.validate}
                      translate={props.translate}
                                      lang={props.lang}
                                      errmsg={props.fstate.lastName.errorlabel}
                                      placeholder={props.fstate.lastName.placeholder}
                    />
                  </div>
                              {/*</div> */}
                <PRInput
                  elem={props.fstate.address}
                  validate={props.validate}
                  translate={props.translate}
                                  lang={props.lang}
                                  errmsg={props.fstate.address.errorlabel}
                                  placeholder={props.fstate.address.placeholder}
                />

                              {/* <div className="flex">*/}
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.addressaptnum}
                      validate={props.validate}
                      translate={props.translate}
                                      lang={props.lang}
                                      errmsg={props.fstate.addressaptnum.errorlabel}
                                      placeholder={props.fstate.addressaptnum.placeholder}
                    />
                  </div>
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.addresscity}
                      validate={props.validate}
                      translate={props.translate}
                                      lang={props.lang}
                                      errmsg={props.fstate.addresscity.errorlabel}
                                      placeholder={props.fstate.addresscity.placeholder}
                    />
                  </div>
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.addresszipcode}
                      validate={props.validate}
                      translate={props.translate}
                                      lang={props.lang}
                                      errmsg={props.fstate.addresszipcode.errorlabel}
                                      placeholder={props.fstate.addresszipcode.placeholder}
                    />
                  </div>
                              {/* </div> */}
                              {/*<div className="flex">*/}
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.phone}
                      validate={props.validate}
                      translate={props.translate}
                      lang={props.lang}
                      errmsg={props.fstate.phone.errorlabel}
                      placeholder={props.fstate.phone.placeholder}
                    />
                  </div>
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.email}
                      validate={props.validate}
                      translate={props.translate}
                        lang={props.lang}
                        errmsg={props.fstate.email.errorlabel}
                        placeholder={props.fstate.email.placeholder}
                    />
                  </div>
                              {/* </div> */}
                <div className="flex">
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.coordinatesx}
                      validate={props.validate}
                      translate={props.translate}
                      lang={props.lang}
                    />
                  </div>
                  <div className="flex-element">
                    <PRInput
                      elem={props.fstate.coordinatesy}
                      validate={props.validate}
                      translate={props.translate}
                      lang={props.lang}
                    />
                  </div>
                </div>

                <PRCheckbox
                  elem={props.fstate.isFollowUpCall}
                  validate={props.validate}
                  translate={props.translate}
                    lang={props.lang}                    
                />

                <PRCheckbox
                  elem={props.fstate.emailRequest}
                  validate={props.validate}
                  translate={props.translate}
                  lang={props.lang}
                />
              </Card>
              <div className="d-flex justify-content-center">
                {/* <Button
                  color="outline-info"
                  onClick={(e) => {
                    openStep(e, 2);
                  }}
                >
                  {props.translate(props.lang, "Back")}
                </Button> */}
                <Button
                  color="info"
                  disabled={props.btnSubmitDisabled}
                                  onClick={(e) => {
                                     
                    submitForm(e); 
                  }}
                >
                  {props.translate(props.lang, "Submit")}
                </Button>
                <Button
                  color="outline-info"
                  className="clearBtn"
                  onClick={(e) => {
                    setStep(1);
                    props.clearForm(e);
                  }}
                >
                  {props.translate(props.lang, "Clear")}
                </Button>
              </div>
              {props.usecaptcha ? (
                <ReCAPTCHA
                  ref={recaptchaRef}
                  size="invisible"
                  sitekey={props.recaptchaSiteKey}
                  onChange={onChange}
                />
              ) : (
                ""
                              )}

                          {props.fstate.reportInfoOnBottom.disable === false ? (
                              <div className="d-flex ">
                                  <Label className="infoBottom" for="reportInfoOnBottom">
                                      <div className="d-flex ">
                                          <span
                                              className={
                                                  props.fstate.reportInfoOnBottom.fontWeight
                                                      ? "label-font"
                                                      : ""
                                              }
                                          >
                                              {props.translate(
                                                  props.lang,
                                                  props.fstate.reportInfoOnBottom.label
                                              )}
                                          </span>
                                      </div>
                                  </Label>
                              </div>
                          ) : (
                                  ""
                              )}

            </>
          ) : (
            ""
          )}
        </Col>
      </Form>
    </div>
  );
}
